module.exports = __webpack_public_path__ + "img/19.0eba57e8.svg";